import { CallList } from '../../call-list/call-list';
import { CallListSchema } from '../../call-list/call-list-schema';

export const getCallListPIIRetentionDuration = (callList?: CallList): string =>
  callList?.getPIIRetentionDuration() ?? CallListSchema.Defaults.pIIRetentionDuration;
